import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Github } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-chapterly-dark-purple text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">ChapterSeed</h3>
            <p className="text-gray-300 mb-4">
              Episodic storytelling platform where authors publish captivating stories, 
              episode by episode.
            </p>
            <div className="flex space-x-4">
              {/* No social presence yet — icons route back to chapterseed.com until real accounts exist. */}
              <a href="https://chapterseed.com" target="_blank" rel="noopener noreferrer" className="hover:text-chapterly-light-purple">
                <Facebook className="h-5 w-5" />
                <span className="sr-only">Facebook</span>
              </a>
              <a href="https://chapterseed.com" target="_blank" rel="noopener noreferrer" className="hover:text-chapterly-light-purple">
                <Twitter className="h-5 w-5" />
                <span className="sr-only">Twitter</span>
              </a>
              <a href="https://chapterseed.com" target="_blank" rel="noopener noreferrer" className="hover:text-chapterly-light-purple">
                <Instagram className="h-5 w-5" />
                <span className="sr-only">Instagram</span>
              </a>
              <a href="https://chapterseed.com" target="_blank" rel="noopener noreferrer" className="hover:text-chapterly-light-purple">
                <Github className="h-5 w-5" />
                <span className="sr-only">Github</span>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Explore</h4>
            <ul className="space-y-2">
              <li><Link to="/browse" className="text-gray-300 hover:text-white">Browse Stories</Link></li>
              <li><Link to="/categories" className="text-gray-300 hover:text-white">Categories</Link></li>
              <li><Link to="/browse?sort=trending" className="text-gray-300 hover:text-white">Trending</Link></li>
              <li><Link to="/browse?sort=new" className="text-gray-300 hover:text-white">New Releases</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">For Authors</h4>
            <ul className="space-y-2">
              <li><Link to="/write" className="text-gray-300 hover:text-white">Start Writing</Link></li>
              <li><Link to="/author-guidelines" className="text-gray-300 hover:text-white">Guidelines</Link></li>
              <li><Link to="/author-dashboard" className="text-gray-300 hover:text-white">Monetization</Link></li>
              <li><Link to="/author-dashboard" className="text-gray-300 hover:text-white">Analytics</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white">About Us</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-white">Blog</Link></li>
              <li><Link to="/careers" className="text-gray-300 hover:text-white">Careers</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white">Contact</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between">
          <p className="text-gray-400">&copy; {new Date().getFullYear()} ChapterSeed. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/terms" className="text-gray-400 hover:text-white">Terms of Service</Link>
            <Link to="/privacy" className="text-gray-400 hover:text-white">Privacy Policy</Link>
            <Link to="/cookies" className="text-gray-400 hover:text-white">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
